


































































































































































































































































import { CenterSetting } from '@core/interfaces/center-setting';
import {
  POSProduct,
  POSProductCancelData,
  POSProductType,
  POSProductTypeConfig,
  POSProductTypeData,
  POSTicket,
  POSTicketDetail,
} from '@pos/interfaces/pos-v2';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import PosCancelProductModal from '@pos/components/v2/pos-cancel-product-modal.vue';
import BpcPosChangeOwnerModal from './pos-change-owner-modal.vue';
import BpcPosChangeProductMandateModal from '@pos/components/v2/pos-change-product-mandate-modal.vue';
import BpcPosChangeBadgeProductModal from '@pos/components/v2/pos-change-badge-product-modal.vue';

@Component({
  name: 'bpc-pos-ticket-detail',
  components: {
    'bpc-pos-cancel-product-modal': PosCancelProductModal,
    BpcPosChangeProductMandateModal,
    BpcPosChangeOwnerModal,
    BpcPosChangeBadgeProductModal,
  },
})
export default class PosTicketDetail extends Vue {
  // PROPS
  @Prop({ type: Number }) readonly ticketId: number;
  @Prop({ type: Number }) readonly contactId: number;
  @Prop({ type: Number, required: true }) readonly posSessionId: number;
  @Prop({ type: Object }) readonly value: POSTicketDetail;
  @Prop({ type: Array }) readonly ticketProductTypes: POSProductTypeData[];
  @Prop({ type: Boolean, default: true }) readonly showAdjustQuantityBtns: boolean;
  @Prop({ type: Boolean, default: true }) readonly showAdjustDiscountBtns: boolean;
  @Prop({ type: Boolean, default: true }) readonly showChangeOwnerBtn: boolean;
  @Prop({ type: Boolean, default: true }) readonly showDeleteBtn: boolean;
  @Prop({ type: Boolean, default: false }) readonly showCancelButton: boolean;
  @Prop({ type: Boolean, default: false }) readonly paid: boolean;
  @Prop({ type: Boolean, default: true }) readonly readOnlyTicket: boolean;
  @Prop({ type: Boolean, default: false }) readonly askForBadgeOnMounted: boolean;
  @Prop({ type: Number, default: 0 }) readonly AskOnMountedOrderItemId: number;

  // DATA
  productCancelData: POSProductCancelData = {
    posSessionId: this.posSessionId,
    originTicketId: this.ticketId,
    destinyTicketId: null,
    contactId: this.contactId,
    productType: null,
    productId: null,
  };
  showCancelModal: boolean = false;
  showChangeOwnerModal: boolean = false;
  showChangeProductMandateModal: boolean = false;
  ownerId: number = null;
  productMandateId: number = null;
  selectedProduct: POSProduct = null;
  selectedProductType: POSProductType = null;
  showAddBadgeModal: boolean = false;
  // COMPUTED
  get ticketDetail(): POSTicketDetail {
    return this.value || null;
  }

  set ticketDetail(value) {
    this.$emit('input', value);
  }

  get centerSetting(): CenterSetting {
    return this.$store.getters['centerSettings/centerSettings'];
  }

  get discountAllowed(): boolean {
    return !!this.centerSetting.pos_discounts_allowed || this.$authService.isAdmin();
  }

  mounted() {
    if (this.askForBadgeOnMounted) {
      for (const productType of this.ticketDetail.productTypes) {
        for (const product of productType.products) {
          if (
            product.id == this.AskOnMountedOrderItemId &&
            productType.type == 'enrollment' &&
            product.requiredSpecifyBadge
          ) {
            this.selectedProduct = product;
            this.selectedProductType = productType.type;
            this.ownerId = product?.owner.id;
            this.showAddBadgeModal = true;
            break;
          }
        }
      }
    }
  }

  isCancelable(productConfig: POSProductTypeConfig) {
    return (
      this.showCancelButton &&
      productConfig.cancelable &&
      (!!this.centerSetting.pos_refunds_allowed || this.$authService.isAdmin())
    );
  }

  cancelProduct(productType: POSProductType, productId: number) {
    this.productCancelData.productType = productType;
    this.productCancelData.productId = productId;
    this.showCancelModal = true;
  }

  closeCancelProductModal() {
    this.showCancelModal = false;
    this.productCancelData.productType = null;
    this.productCancelData.productId = null;
  }

  onCheckoutTicket($event: POSTicket) {
    this.$emit('checkout-ticket', $event);
  }

  async postQuantityIfStopChanging(productType, product) {
    const q = product.quantity;
    setTimeout(async () => {
      const newQ = product.quantity;
      if (q === newQ) {
        const newTicketDetail = await this.$posService.changeProductQuantity(
          this.posSessionId,
          this.ticketDetail.id,
          productType,
          product.id,
          newQ,
        );
        this.ticketDetail = newTicketDetail;
        this.$emit('ticket-detail-updated', newTicketDetail);
      }
    }, 300);
  }

  async addQuantity(productType: POSProductType, product: POSProduct) {
    console.log('addQuantity', productType, product);
    if (product.quantity === -1) {
      // Go directly to +1, not allowing 0
      product.quantity = 1;
    } else {
      product.quantity++;
    }
    await this.postQuantityIfStopChanging(productType, product);
  }

  async subtractQuantity(productType: POSProductType, product: POSProduct) {
    if (product.quantity === 1) {
      // Go directly to -1, not allowing 0
      product.quantity = -1;
    } else {
      product.quantity--;
    }
    this.postQuantityIfStopChanging(productType, product);
  }

  changeOwner(productType: POSProductType, product: POSProduct) {
    this.selectedProduct = product;
    this.selectedProductType = productType;
    this.ownerId = product?.owner.id;
    this.showChangeOwnerModal = true;
  }
  addSecondaryBadge(productType: POSProductType, product: POSProduct) {
    this.selectedProduct = product;
    this.selectedProductType = productType;
    this.ownerId = product?.owner.id;
    this.showAddBadgeModal = true;
  }

  changeProductMandate(productType: POSProductType, product: POSProduct) {
    this.selectedProduct = product;
    this.selectedProductType = productType;
    this.ownerId = product?.owner.id;
    this.productMandateId = product?.mandateId;
    this.showChangeProductMandateModal = true;
  }

  onOwnerChanged(newTicketDetail: POSTicketDetail) {
    this.ticketDetail = newTicketDetail;
    this.$emit('ticket-detail-updated', newTicketDetail);
    this.$emit('contact-updated', newTicketDetail.contact);
  }

  onMandateUpdated(newTicketDetail: POSTicketDetail) {
    this.ticketDetail = newTicketDetail;
    this.$emit('ticket-detail-updated', newTicketDetail);
    this.$emit('contact-updated', newTicketDetail.contact);
  }

  hasOtherProductOwner(product): boolean {
    return product.owner && product.owner.id !== this.contactId;
  }

  async removeProduct(productType: POSProductType, product: POSProduct) {
    const newTicketDetail = await this.$posService.removeProduct(
      this.posSessionId,
      this.ticketDetail.id,
      productType,
      product.id,
    );
    this.ticketDetail = newTicketDetail;
    this.$emit('ticket-detail-updated', newTicketDetail);
  }
  async applyPriceEditionClicked(product: POSProduct, productCategory: POSProductType) {
    if (!this.discountAllowed && !product.editablePrice) {
      return;
    }
    this.$emit('apply-price-edition-clicked', { product, productCategory });
  }

  productNeedsToSpecifyBadge(productType: POSProductType, product: POSProduct): boolean {
    return (
      (productType === 'entry' && !product.useBarcode && product.requiredSpecifyBadge) ||
      (productType === 'enrollment' && product.requiredSpecifyBadge)
    );
  }
}
